import { useContext } from 'react';
import { onClickContext } from './context';

export const useOnClick = () => {
  const onClick = useContext(onClickContext);
  return onClick;
};
